import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import ModalDialog, { ModalBody, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';

import { HierarchyChart } from './HierarchyChart';
import type { HierarchyData } from './types';

const messages = defineMessages({
	hierarchyModalTitle: {
		id: 'reporting-lines.hierarchy-modal.title',
		defaultMessage: 'Reporting line',
		description: 'Title for the hierarchy chart modal',
	},
});

export interface HierarchyModalProps {
	data: HierarchyData;
	onClose: () => void;
	title?: string;
	testId?: string;
}

/**
 * Renders a hierarchy chart inside a modal dialog.
 * Common use case for displaying org chart on demand (e.g. from inline previews, profile cards).
 *
 * @internal Not ready for consumption. Do not use in production.
 */
export function HierarchyModal({
	data,
	onClose,
	title,
	testId = 'hierarchy-modal',
}: HierarchyModalProps): React.JSX.Element {
	const intl = useIntl();
	const modalTitle = title ?? intl.formatMessage(messages.hierarchyModalTitle);

	return (
		<ModalDialog onClose={onClose} width="medium" testId={testId}>
			<ModalHeader hasCloseButton>
				<ModalTitle>{modalTitle}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<HierarchyChart data={data} />
			</ModalBody>
		</ModalDialog>
	);
}
